import { DesignSettings } from '../types/DesignSettings';
import { DEFAULT_DESIGN_SETTINGS } from './defaultDesignSettings';

// Classic Template Defaults
export const CLASSIC_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: 'original',
  layoutType: 'horizontal',
  socialMediaIconType: 'filled',
  themeColor: '#ffffff',
  socialBanner: {
    backgroundColor: '#45668E',
    iconAlignment: 'left'
  }
};

// Strip Template Defaults
export const STRIP_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: '#45668E',
  layoutType: 'horizontal',
  horizontalLineStyle: 'none',
  separatorType: 'line',
  lineStyle: 'solid',
  decorativeLineColor: '#BDBDBD',
  headerColor: '#45668E',
  fontFamily: 'Arial',
  fontSize: 14,
  nameFontSize: 18,
  lineHeight: 1.08,
  padding: 10,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#212121',
  fontScale: 0,
  lineSpacing: 108,
  socialMediaIconType: 'stroke',
  socialMediaIconShape: 'circle',
  socialMediaIconSize: 24,
  themeColor: '#45668E',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'left',
  customSpace: 6,
  socialIconSpacing: 4,
  separatorColor: '#45668E',
  direction: 'horizontal',
  imageShape: 'square',
  subHeaderColor: '#646464',
  labelType: 'icon',
  imageSize: 70,
  bodyColor: '#45668E',
  socialBanner: {
    backgroundColor: '#45668E',
    iconAlignment: 'right'
  }
};

// Horizontal Template Defaults
export const HORIZONTAL_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: 'original',
  layoutType: 'hybrid',
  horizontalLineStyle: 'solid',
  separatorType: 'line',
  lineStyle: 'none',
  decorativeLineColor: '#D9D9D9',
  headerColor: '#45668E',
  fontFamily: 'Arial',
  fontSize: 13,
  nameFontSize: 16,
  lineHeight: 1.08,
  padding: 10,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#212121',
  fontScale: 0,
  lineSpacing: 108,
  socialMediaIconType: 'filled',
  socialMediaIconShape: 'circle',
  socialMediaIconSize: 24,
  themeColor: '#ffffff',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'left',
  customSpace: 6,
  socialIconSpacing: 4,
  separatorColor: '#BDBDBD',
  direction: 'horizontal',
  imageShape: 'square',
  subHeaderColor: '#646464',
  labelType: 'none',
  imageSize: 70,
  bodyColor: '#45668E',
  socialBanner: {
    backgroundColor: '#ffffff',
    iconAlignment: 'left'
  }
};

// Wide Template Defaults
export const WIDE_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: 'original',
  layoutType: 'vertical',
  horizontalLineStyle: 'solid',
  separatorType: 'line',
  lineStyle: 'none',
  decorativeLineColor: '#BDBDBD',
  headerColor: '#45668E',
  fontFamily: 'Arial',
  fontSize: 14,
  nameFontSize: 18,
  lineHeight: 1.08,
  padding: 10,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#212121',
  fontScale: 0,
  lineSpacing: 108,
  socialMediaIconType: 'filled',
  socialMediaIconShape: 'square',
  socialMediaIconSize: 30,
  themeColor: '#ffffff',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'left',
  customSpace: 6,
  socialIconSpacing: 4,
  separatorColor: '#45668E',
  direction: 'horizontal',
  imageShape: 'square',
  subHeaderColor: '#646464',
  labelType: 'none',
  imageSize: 70,
  bodyColor: '#45668E',
  socialBanner: {
    backgroundColor: '#ffffff',
    iconAlignment: 'right'
  }
};

// Compact Template Defaults
export const COMPACT_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: '#45668E',
  layoutType: 'vertical',
  horizontalLineStyle: 'none',
  separatorType: 'line',
  lineStyle: 'none',
  decorativeLineColor: '#BDBDBD',
  headerColor: '#45668E',
  fontFamily: 'Arial',
  fontSize: 14,
  nameFontSize: 18,
  lineHeight: 1.08,
  padding: 10,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#212121',
  fontScale: 0,
  lineSpacing: 108,
  socialMediaIconType: 'filled',
  socialMediaIconShape: 'circle',
  socialMediaIconSize: 24,
  themeColor: '#ffffff',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'left',
  customSpace: 6,
  socialIconSpacing: 4,
  separatorColor: '#45668E',
  direction: 'ltr',
  imageShape: 'circle',
  subHeaderColor: '#646464',
  labelType: 'icon',
  imageSize: 70,
  bodyColor: '#45668E',
  socialBanner: {
    backgroundColor: '#ffffff',
    iconAlignment: 'left'
  }
};

// Stacked Template Defaults
export const STACKED_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: '#45668E',
  layoutType: 'horizontal',
  horizontalLineStyle: 'none',
  separatorType: 'none',
  lineStyle: 'solid',
  decorativeLineColor: '#BDBDBD',
  headerColor: '#646464',
  fontFamily: 'Arial',
  fontSize: 14,
  nameFontSize: 18,
  lineHeight: 1.08,
  padding: 10,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#212121',
  fontScale: 0,
  lineSpacing: 108,
  socialMediaIconType: 'filled',
  socialMediaIconShape: 'square',
  socialMediaIconSize: 24,
  themeColor: '#ffffff',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'left',
  customSpace: 6,
  socialIconSpacing: 4,
  separatorColor: '#BDBDBD',
  direction: 'horizontal',
  imageShape: 'rounded',
  subHeaderColor: '#646464',
  labelType: 'icon',
  imageSize: 70,
  bodyColor: '#45668E',
  socialBanner: {
    backgroundColor: '#ffffff',
    iconAlignment: 'left'
  }
};

// Corporate Template Defaults
export const CORPORATE_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: '#333333',
  layoutType: 'vertical',
  horizontalLineStyle: 'none',
  separatorType: 'line',
  lineStyle: 'solid',
  decorativeLineColor: '#CCCCCC',
  headerColor: '#45668E',
  subHeaderColor: '#212121',
  fontFamily: 'Arial',
  fontSize: 14,
  nameFontSize: 20,
  lineHeight: 1.08,
  padding: 10,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#ffffff',
  fontScale: 0,
  lineSpacing: 108,
  socialMediaIconType: 'text',
  socialMediaIconShape: 'square',
  socialMediaIconSize: 24,
  themeColor: '#45668E',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'left',
  customSpace: 0,
  spaceBelowFarewell: 4,
  socialIconSpacing: 4,
  separatorColor: '#CCCCCC',
  direction: 'horizontal',
  imageShape: 'circle',
  labelType: 'p',
  imageSize: 70,
  useThemeColorForContactInfo: true,
  bodyColor: '#ffffff',
  socialBanner: {
    backgroundColor: '#ffffff',
    iconAlignment: 'left'
  }
};

// Social Template Defaults
export const SOCIAL_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: 'original',
  layoutType: 'hybrid',
  horizontalLineStyle: 'none',
  separatorType: 'none',
  lineStyle: 'solid',
  decorativeLineColor: '#BDBDBD',
  headerColor: '#45668E',
  fontFamily: 'Arial',
  fontSize: 14,
  nameFontSize: 18,
  lineHeight: 1.08,
  padding: 10,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#212121',
  fontScale: 0,
  lineSpacing: 108,
  socialMediaIconType: 'filled',
  socialMediaIconShape: 'square',
  socialMediaIconSize: 24,
  themeColor: '#ffffff',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'left',
  verticalAlignment: 'center',
  customSpace: 6,
  socialIconSpacing: 4,
  separatorColor: '#BDBDBD',
  direction: 'horizontal',
  imageShape: 'rounded',
  subHeaderColor: '#646464',
  labelType: 'icon',
  imageSize: 70,
  bodyColor: '#45668E',
  socialBanner: {
    backgroundColor: '#ffffff',
    iconAlignment: 'left'
  },
  farewellSignature: {
    signOffType: 'signoff',
    signOffSize: 32,
    signOffAlignment: 'left',
    signOffSignOff: 'sincerely',
    signOffFont: 'boss_signature'
  }
};

// Central Template Defaults
export const CENTRAL_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: '#4a6c95',
  layoutType: 'vertical',
  horizontalLineStyle: 'none',
  separatorType: 'line',
  lineStyle: 'none',
  decorativeLineColor: '#4a6c95',
  headerColor: '#4a6c95',
  fontFamily: 'Arial',
  fontSize: 13,
  nameFontSize: 16,
  lineHeight: 1.08,
  padding: 10,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#212121',
  fontScale: 0,
  lineSpacing: 100,
  socialMediaIconType: 'filled',
  socialMediaIconShape: 'circle',
  socialMediaIconSize: 24,
  themeColor: '#ffffff',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'left',
  customSpace: 6,
  socialIconSpacing: 4,
  separatorColor: '#4a6c95',
  direction: 'horizontal',
  imageShape: 'circle',
  subHeaderColor: '#646464',
  labelType: 'phone',
  bodyColor: '#4a6c95',
  imageSize: 70,
  socialBanner: {
    backgroundColor: '#ffffff',
    iconAlignment: 'right'
  }
};

// Footer Template Defaults
export const FOOTER_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: '#45668E',
  layoutType: 'horizontal',
  horizontalLineStyle: 'none',
  separatorType: 'line',
  lineStyle: 'none',
  decorativeLineColor: '#BDBDBD',
  headerColor: '#45668E',
  fontFamily: 'Arial',
  fontSize: 13,
  nameFontSize: 16,
  lineHeight: 1.08,
  padding: 10,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#ffffff',
  fontScale: 0,
  lineSpacing: 108,
  socialMediaIconType: 'filled',
  socialMediaIconShape: 'circle',
  socialMediaIconSize: 24,
  themeColor: '#45668E',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'center',
  customSpace: 6,
  socialIconSpacing: 4,
  separatorColor: '#BDBDBD',
  direction: 'horizontal',
  imageShape: 'circle',
  subHeaderColor: '#212121',
  labelType: 'p',
  imageSize: 70,
  bodyColor: '#ffffff',
  socialBanner: {
    backgroundColor: '#45668E',
    iconAlignment: 'center'
  }
};

// Topbar Template Defaults
export const TOPBAR_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: 'original',
  layoutType: 'hybrid',
  horizontalLineStyle: 'none',
  separatorType: 'none',
  lineStyle: 'none',
  decorativeLineColor: '#BDBDBD',
  headerColor: '#FFFFFF',
  fontFamily: 'Arial',
  fontSize: 13,
  nameFontSize: 16,
  lineHeight: 1.08,
  padding: 0,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#212121',
  fontScale: 0,
  lineSpacing: 108,
  socialMediaIconType: 'text',
  socialMediaIconShape: 'square',
  socialMediaIconSize: 24,
  themeColor: '#ffffff',
  headerBarColor: '#45668E',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'left',
  customSpace: 6,
  socialIconSpacing: 4,
  separatorColor: '#BDBDBD',
  direction: 'horizontal',
  imageShape: 'square',
  subHeaderColor: '#FFFFFF',
  labelType: 'none',
  imageSize: 70,
  bodyColor: '#45668E',
  socialBanner: {
    backgroundColor: '#ffffff',
    iconAlignment: 'left'
  }
};

// Rightside Template Defaults
export const RIGHTSIDE_DEFAULTS: DesignSettings = {
  ...DEFAULT_DESIGN_SETTINGS,
  backgroundColor: '#ffffff',
  textColor: '#45668E',
  layoutType: 'hybrid',
  horizontalLineStyle: 'none',
  separatorType: 'line',
  lineStyle: 'none',
  decorativeLineColor: '#CCCCCC',
  headerColor: '#45668E',
  fontFamily: 'Arial',
  fontSize: 14,
  nameFontSize: 20,
  lineHeight: 1.08,
  padding: 10,
  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,
  shadowColor: '#000000',
  shadowBlur: 0,
  shadowOffset: 0,
  contactColor: '#666666',
  fontScale: 0,
  lineSpacing: 108,
  socialMediaIconType: 'filled',
  socialMediaIconShape: 'circle',
  socialMediaIconSize: 24,
  themeColor: '#ffffff',
  imageVerticalAlign: 'top',
  imageHorizontalAlign: 'left',
  customSpace: 6,
  socialIconSpacing: 4,
  separatorColor: '#CCCCCC',
  direction: 'horizontal',
  imageShape: 'circle',
  subHeaderColor: '#646464',
  labelType: 'icon',
  imageSize: 70,
  bodyColor: '#45668E',
  socialBanner: {
    backgroundColor: '#ffffff',
    iconAlignment: 'left'
  }
}; 